// extracted by mini-css-extract-plugin
export default {"charts":"chart_charts__C8xAC","card":"chart_card__jdYnu"};